// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { RestRestCheckRetrieveResponse, ParametrosListData, ParametrosListResponse, ParametrosRetrievePorChaveData, ParametrosRetrievePorChaveResponse, ParametrosRetrievePorIdData, ParametrosRetrievePorIdResponse, AboutmeCreateData, AboutmeCreateResponse, AboutmeListResponse, AboutmePartialUpdateData, AboutmePartialUpdateResponse, AboutmeDestroyData, AboutmeDestroyResponse, AboutmeUpdateData, AboutmeUpdateResponse, AboutmeRetrieveData, AboutmeRetrieveResponse, ContatoProfissionalCreateData, ContatoProfissionalCreateResponse, ContatoProfissionalSubjectsRetrieveResponse, UsersCreateData, UsersCreateResponse, UsersListData, UsersListResponse, UsersPartialUpdateData, UsersPartialUpdateResponse, UsersDestroyData, UsersDestroyResponse, UsersUpdateData, UsersUpdateResponse, UsersRetrieveData, UsersRetrieveResponse, BlogCreateData, BlogCreateResponse, BlogListData, BlogListResponse, BlogPartialUpdateData, BlogPartialUpdateResponse, BlogDestroyData, BlogDestroyResponse, BlogUpdateData, BlogUpdateResponse, BlogRetrieveData, BlogRetrieveResponse, ToolsCreateData, ToolsCreateResponse, ToolsListData, ToolsListResponse, ProxyToolData, ProxyToolResponse, ToolsRandomRetrieveResponse, ToolsPartialUpdateData, ToolsPartialUpdateResponse, ToolsDestroyData, ToolsDestroyResponse, ToolsUpdateData, ToolsUpdateResponse, ToolsRetrieveData, ToolsRetrieveResponse, MotdCreateData, MotdCreateResponse, MotdListData, MotdListResponse, MotdRandomRetrieveResponse, MotdPartialUpdateData, MotdPartialUpdateResponse, MotdDestroyData, MotdDestroyResponse, MotdUpdateData, MotdUpdateResponse, MotdRetrieveData, MotdRetrieveResponse, MotdConfigCreateData, MotdConfigCreateResponse, MotdConfigListData, MotdConfigListResponse, MotdConfigSingletonRetrieveResponse, MotdConfigPartialUpdateData, MotdConfigPartialUpdateResponse, MotdConfigDestroyData, MotdConfigDestroyResponse, MotdConfigUpdateData, MotdConfigUpdateResponse, MotdConfigRetrieveData, MotdConfigRetrieveResponse, ParceriaServicosListData, ParceriaServicosListResponse, ParceriaServicosRetrieveData, ParceriaServicosRetrieveResponse, ParceriaPedidosCreateResponse, ParceriaPedidosListData, ParceriaPedidosListResponse, ParceriaPedidosPartialUpdateData, ParceriaPedidosPartialUpdateResponse, ParceriaPedidosDestroyData, ParceriaPedidosDestroyResponse, ParceriaPedidosUpdateData, ParceriaPedidosUpdateResponse, ParceriaPedidosRetrieveData, ParceriaPedidosRetrieveResponse, ParceriaPedidosCancelarCreateData, ParceriaPedidosCancelarCreateResponse, ParceriaPedidosConcluirCreateData, ParceriaPedidosConcluirCreateResponse, ParceriaContratosCreateData, ParceriaContratosCreateResponse, ParceriaContratosListData, ParceriaContratosListResponse, ParceriaContratosPartialUpdateData, ParceriaContratosPartialUpdateResponse, ParceriaContratosDestroyData, ParceriaContratosDestroyResponse, ParceriaContratosUpdateData, ParceriaContratosUpdateResponse, ParceriaContratosRetrieveData, ParceriaContratosRetrieveResponse, ParceriaTicketsCreateData, ParceriaTicketsCreateResponse, ParceriaTicketsListData, ParceriaTicketsListResponse, ParceriaTicketsPartialUpdateData, ParceriaTicketsPartialUpdateResponse, ParceriaTicketsDestroyData, ParceriaTicketsDestroyResponse, ParceriaTicketsUpdateData, ParceriaTicketsUpdateResponse, ParceriaTicketsRetrieveData, ParceriaTicketsRetrieveResponse, ParceriaTicketsResponderCreateData, ParceriaTicketsResponderCreateResponse } from './types.gen';

export class RestService {
    /**
     * Check REST API
     * This endpoint checks if the REST API is working.
     * @returns Message
     * @throws ApiError
     */
    public static restRestCheckRetrieve(): CancelablePromise<RestRestCheckRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/rest/rest-check/'
        });
    }
    
}

export class ParametrosService {
    /**
     * Acesso dos parâmetros de sistema configuráveis.
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedParametroSistemaList
     * @throws ApiError
     */
    public static parametrosList(data: ParametrosListData = {}): CancelablePromise<ParametrosListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parametros/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * Busca um parâmetro de sistema pelo valor da chave.
     * Útil para configuração dinâmica no frontend.
     * @param data The data for the request.
     * @param data.chave
     * @returns ParametroSistema
     * @throws ApiError
     */
    public static parametrosRetrievePorChave(data: ParametrosRetrievePorChaveData): CancelablePromise<ParametrosRetrievePorChaveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parametros/{chave}/',
            path: {
                chave: data.chave
            }
        });
    }
    
    /**
     * Acesso dos parâmetros de sistema configuráveis.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this parametro sistema.
     * @returns ParametroSistema
     * @throws ApiError
     */
    public static parametrosRetrievePorId(data: ParametrosRetrievePorIdData): CancelablePromise<ParametrosRetrievePorIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parametros/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class AboutmeService {
    /**
     * Informações do dono do site.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AboutMe
     * @throws ApiError
     */
    public static aboutmeCreate(data: AboutmeCreateData): CancelablePromise<AboutmeCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/aboutme/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Informações do dono do site.
     * @returns AboutMe
     * @throws ApiError
     */
    public static aboutmeList(): CancelablePromise<AboutmeListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/aboutme/'
        });
    }
    
    /**
     * Informações do dono do site.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this about me.
     * @param data.requestBody
     * @returns AboutMe
     * @throws ApiError
     */
    public static aboutmePartialUpdate(data: AboutmePartialUpdateData): CancelablePromise<AboutmePartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/aboutme/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Informações do dono do site.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this about me.
     * @returns void No response body
     * @throws ApiError
     */
    public static aboutmeDestroy(data: AboutmeDestroyData): CancelablePromise<AboutmeDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/aboutme/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Atualiza os dados do autor. Apenas usuários administradores têm permissão.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this about me.
     * @param data.requestBody
     * @returns AboutMe
     * @throws ApiError
     */
    public static aboutmeUpdate(data: AboutmeUpdateData): CancelablePromise<AboutmeUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/aboutme/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Retorna os dados do autor. Espera um ID como parâmetro.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this about me.
     * @returns AboutMe
     * @throws ApiError
     */
    public static aboutmeRetrieve(data: AboutmeRetrieveData): CancelablePromise<AboutmeRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/aboutme/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class ContatoProfissionalService {
    /**
     * Endpoint para envio de mensagens através do formulário de contato profissional.
     *
     * Permite envio de mensagens públicas que podem ser rastreadas via UTM.
     * As mensagens são validadas, armazenas e notificações por email podem ser disparadas.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ProfessionalContactMessageCreate
     * @throws ApiError
     */
    public static contatoProfissionalCreate(data: ContatoProfissionalCreateData): CancelablePromise<ContatoProfissionalCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/contato-profissional/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Listar assuntos disponíveis
     * Retorna as opções de assunto válidas para mensagens de contato profissional.
     * @returns string Dicionário com as opções disponíveis. Chave/valor para o backend, valor = label exibida no frontend.
     * @throws ApiError
     */
    public static contatoProfissionalSubjectsRetrieve(): CancelablePromise<ContatoProfissionalSubjectsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/contato-profissional/subjects/'
        });
    }
    
}

export class UsersService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns User
     * @throws ApiError
     */
    public static usersCreate(data: UsersCreateData): CancelablePromise<UsersCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedUserList
     * @throws ApiError
     */
    public static usersList(data: UsersListData = {}): CancelablePromise<UsersListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this user.
     * @param data.requestBody
     * @returns User
     * @throws ApiError
     */
    public static usersPartialUpdate(data: UsersPartialUpdateData): CancelablePromise<UsersPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/users/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this user.
     * @returns void No response body
     * @throws ApiError
     */
    public static usersDestroy(data: UsersDestroyData): CancelablePromise<UsersDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this user.
     * @param data.requestBody
     * @returns User
     * @throws ApiError
     */
    public static usersUpdate(data: UsersUpdateData): CancelablePromise<UsersUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this user.
     * @returns User
     * @throws ApiError
     */
    public static usersRetrieve(data: UsersRetrieveData): CancelablePromise<UsersRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class BlogService {
    /**
     * API para listagem, filtro e recuperação de posts do blog.
     * @param data The data for the request.
     * @param data.requestBody
     * @returns BlogPost
     * @throws ApiError
     */
    public static blogCreate(data: BlogCreateData): CancelablePromise<BlogCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/blog/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API para listagem, filtro e recuperação de posts do blog.
     * @param data The data for the request.
     * @param data.tagsNome
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedBlogPostList
     * @throws ApiError
     */
    public static blogList(data: BlogListData = {}): CancelablePromise<BlogListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/blog/',
            query: {
                tags__nome: data.tagsNome,
                page: data.page
            }
        });
    }
    
    /**
     * API para listagem, filtro e recuperação de posts do blog.
     * @param data The data for the request.
     * @param data.slug
     * @param data.requestBody
     * @returns BlogPost
     * @throws ApiError
     */
    public static blogPartialUpdate(data: BlogPartialUpdateData): CancelablePromise<BlogPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/blog/{slug}/',
            path: {
                slug: data.slug
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API para listagem, filtro e recuperação de posts do blog.
     * @param data The data for the request.
     * @param data.slug
     * @returns void No response body
     * @throws ApiError
     */
    public static blogDestroy(data: BlogDestroyData): CancelablePromise<BlogDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/blog/{slug}/',
            path: {
                slug: data.slug
            }
        });
    }
    
    /**
     * API para listagem, filtro e recuperação de posts do blog.
     * @param data The data for the request.
     * @param data.slug
     * @param data.requestBody
     * @returns BlogPost
     * @throws ApiError
     */
    public static blogUpdate(data: BlogUpdateData): CancelablePromise<BlogUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/blog/{slug}/',
            path: {
                slug: data.slug
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * API para listagem, filtro e recuperação de posts do blog.
     * @param data The data for the request.
     * @param data.slug
     * @returns BlogPost
     * @throws ApiError
     */
    public static blogRetrieve(data: BlogRetrieveData): CancelablePromise<BlogRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/blog/{slug}/',
            path: {
                slug: data.slug
            }
        });
    }
    
}

export class ToolsService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns Tool
     * @throws ApiError
     */
    public static toolsCreate(data: ToolsCreateData): CancelablePromise<ToolsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tools/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id
     * @param data.category * `conversao` - Conversão
     * * `gerador` - Gerador
     * * `validacao` - Validacão
     * * `calculadora` - Calculadora
     * * `simulador` - Simulador
     * * `codificacao` - Codificação
     * * `tradutor` - Tradutor
     * * `utilitario` - Utilitário Geral
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedToolList
     * @throws ApiError
     */
    public static toolsList(data: ToolsListData = {}): CancelablePromise<ToolsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tools/',
            query: {
                id: data.id,
                category: data.category,
                page: data.page
            }
        });
    }
    
    /**
     * Encaminha a requisição para a API da ferramenta usando slug
     * @param data The data for the request.
     * @param data.slug
     * @param data.requestBody
     * @returns unknown
     * @throws ApiError
     */
    public static proxyTool(data: ProxyToolData): CancelablePromise<ProxyToolResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tools/proxy/{slug}/',
            path: {
                slug: data.slug
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @returns Tool
     * @throws ApiError
     */
    public static toolsRandomRetrieve(): CancelablePromise<ToolsRandomRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tools/random/'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.slug
     * @param data.requestBody
     * @returns Tool
     * @throws ApiError
     */
    public static toolsPartialUpdate(data: ToolsPartialUpdateData): CancelablePromise<ToolsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tools/{slug}/',
            path: {
                slug: data.slug
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.slug
     * @returns void No response body
     * @throws ApiError
     */
    public static toolsDestroy(data: ToolsDestroyData): CancelablePromise<ToolsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tools/{slug}/',
            path: {
                slug: data.slug
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.slug
     * @param data.requestBody
     * @returns Tool
     * @throws ApiError
     */
    public static toolsUpdate(data: ToolsUpdateData): CancelablePromise<ToolsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tools/{slug}/',
            path: {
                slug: data.slug
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.slug
     * @returns Tool
     * @throws ApiError
     */
    public static toolsRetrieve(data: ToolsRetrieveData): CancelablePromise<ToolsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tools/{slug}/',
            path: {
                slug: data.slug
            }
        });
    }
    
}

export class MotdService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MOTD
     * @throws ApiError
     */
    public static motdCreate(data: MotdCreateData): CancelablePromise<MotdCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/motd/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedMOTDList
     * @throws ApiError
     */
    public static motdList(data: MotdListData = {}): CancelablePromise<MotdListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/motd/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * @returns MOTD
     * @throws ApiError
     */
    public static motdRandomRetrieve(): CancelablePromise<MotdRandomRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/motd/random/'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd.
     * @param data.requestBody
     * @returns MOTD
     * @throws ApiError
     */
    public static motdPartialUpdate(data: MotdPartialUpdateData): CancelablePromise<MotdPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/motd/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd.
     * @returns void No response body
     * @throws ApiError
     */
    public static motdDestroy(data: MotdDestroyData): CancelablePromise<MotdDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/motd/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd.
     * @param data.requestBody
     * @returns MOTD
     * @throws ApiError
     */
    public static motdUpdate(data: MotdUpdateData): CancelablePromise<MotdUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/motd/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd.
     * @returns MOTD
     * @throws ApiError
     */
    public static motdRetrieve(data: MotdRetrieveData): CancelablePromise<MotdRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/motd/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class MotdConfigService {
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns MOTDConfig
     * @throws ApiError
     */
    public static motdConfigCreate(data: MotdConfigCreateData = {}): CancelablePromise<MotdConfigCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/motd-config/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedMOTDConfigList
     * @throws ApiError
     */
    public static motdConfigList(data: MotdConfigListData = {}): CancelablePromise<MotdConfigListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/motd-config/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * @returns MOTDConfig
     * @throws ApiError
     */
    public static motdConfigSingletonRetrieve(): CancelablePromise<MotdConfigSingletonRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/motd-config/singleton/'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd config.
     * @param data.requestBody
     * @returns MOTDConfig
     * @throws ApiError
     */
    public static motdConfigPartialUpdate(data: MotdConfigPartialUpdateData): CancelablePromise<MotdConfigPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/motd-config/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd config.
     * @returns void No response body
     * @throws ApiError
     */
    public static motdConfigDestroy(data: MotdConfigDestroyData): CancelablePromise<MotdConfigDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/motd-config/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd config.
     * @param data.requestBody
     * @returns MOTDConfig
     * @throws ApiError
     */
    public static motdConfigUpdate(data: MotdConfigUpdateData): CancelablePromise<MotdConfigUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/motd-config/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this motd config.
     * @returns MOTDConfig
     * @throws ApiError
     */
    public static motdConfigRetrieve(data: MotdConfigRetrieveData): CancelablePromise<MotdConfigRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/motd-config/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class ParceriaService {
    /**
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedServicoList
     * @throws ApiError
     */
    public static parceriaServicosList(data: ParceriaServicosListData = {}): CancelablePromise<ParceriaServicosListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/servicos/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this servico.
     * @returns Servico
     * @throws ApiError
     */
    public static parceriaServicosRetrieve(data: ParceriaServicosRetrieveData): CancelablePromise<ParceriaServicosRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/servicos/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @returns PedidoServico
     * @throws ApiError
     */
    public static parceriaPedidosCreate(): CancelablePromise<ParceriaPedidosCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/parceria/pedidos/'
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedPedidoServicoList
     * @throws ApiError
     */
    public static parceriaPedidosList(data: ParceriaPedidosListData = {}): CancelablePromise<ParceriaPedidosListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/pedidos/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this pedido servico.
     * @returns PedidoServico
     * @throws ApiError
     */
    public static parceriaPedidosPartialUpdate(data: ParceriaPedidosPartialUpdateData): CancelablePromise<ParceriaPedidosPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/parceria/pedidos/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this pedido servico.
     * @returns void No response body
     * @throws ApiError
     */
    public static parceriaPedidosDestroy(data: ParceriaPedidosDestroyData): CancelablePromise<ParceriaPedidosDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/parceria/pedidos/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this pedido servico.
     * @returns PedidoServico
     * @throws ApiError
     */
    public static parceriaPedidosUpdate(data: ParceriaPedidosUpdateData): CancelablePromise<ParceriaPedidosUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/parceria/pedidos/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this pedido servico.
     * @returns PedidoServico
     * @throws ApiError
     */
    public static parceriaPedidosRetrieve(data: ParceriaPedidosRetrieveData): CancelablePromise<ParceriaPedidosRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/pedidos/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this pedido servico.
     * @returns PedidoServico
     * @throws ApiError
     */
    public static parceriaPedidosCancelarCreate(data: ParceriaPedidosCancelarCreateData): CancelablePromise<ParceriaPedidosCancelarCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/parceria/pedidos/{id}/cancelar/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Mixin para tornar o método create (POST padrão do DRF) idempotente via Redis.
     *
     * Importante:
     * - Aplica-se APENAS ao método create().
     * - Não cobre @action(methods=["post"]).
     * - Actions que exigem idempotência devem implementar lógica própria
     * ou delegar explicitamente para este mixin.
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this pedido servico.
     * @returns PedidoServico
     * @throws ApiError
     */
    public static parceriaPedidosConcluirCreate(data: ParceriaPedidosConcluirCreateData): CancelablePromise<ParceriaPedidosConcluirCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/parceria/pedidos/{id}/concluir/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns ContratoServico
     * @throws ApiError
     */
    public static parceriaContratosCreate(data: ParceriaContratosCreateData = {}): CancelablePromise<ParceriaContratosCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/parceria/contratos/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedContratoServicoList
     * @throws ApiError
     */
    public static parceriaContratosList(data: ParceriaContratosListData = {}): CancelablePromise<ParceriaContratosListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/contratos/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this Contrato de Serviço.
     * @param data.requestBody
     * @returns ContratoServico
     * @throws ApiError
     */
    public static parceriaContratosPartialUpdate(data: ParceriaContratosPartialUpdateData): CancelablePromise<ParceriaContratosPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/parceria/contratos/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this Contrato de Serviço.
     * @returns void No response body
     * @throws ApiError
     */
    public static parceriaContratosDestroy(data: ParceriaContratosDestroyData): CancelablePromise<ParceriaContratosDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/parceria/contratos/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this Contrato de Serviço.
     * @param data.requestBody
     * @returns ContratoServico
     * @throws ApiError
     */
    public static parceriaContratosUpdate(data: ParceriaContratosUpdateData): CancelablePromise<ParceriaContratosUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/parceria/contratos/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this Contrato de Serviço.
     * @returns ContratoServico
     * @throws ApiError
     */
    public static parceriaContratosRetrieve(data: ParceriaContratosRetrieveData): CancelablePromise<ParceriaContratosRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/contratos/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.requestBody
     * @returns TicketSuporte
     * @throws ApiError
     */
    public static parceriaTicketsCreate(data: ParceriaTicketsCreateData): CancelablePromise<ParceriaTicketsCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/parceria/tickets/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.page A page number within the paginated result set.
     * @returns PaginatedTicketSuporteList
     * @throws ApiError
     */
    public static parceriaTicketsList(data: ParceriaTicketsListData = {}): CancelablePromise<ParceriaTicketsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/tickets/',
            query: {
                page: data.page
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this ticket suporte.
     * @param data.requestBody
     * @returns TicketSuporte
     * @throws ApiError
     */
    public static parceriaTicketsPartialUpdate(data: ParceriaTicketsPartialUpdateData): CancelablePromise<ParceriaTicketsPartialUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/parceria/tickets/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this ticket suporte.
     * @returns void No response body
     * @throws ApiError
     */
    public static parceriaTicketsDestroy(data: ParceriaTicketsDestroyData): CancelablePromise<ParceriaTicketsDestroyResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/parceria/tickets/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this ticket suporte.
     * @param data.requestBody
     * @returns TicketSuporte
     * @throws ApiError
     */
    public static parceriaTicketsUpdate(data: ParceriaTicketsUpdateData): CancelablePromise<ParceriaTicketsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/parceria/tickets/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this ticket suporte.
     * @returns TicketSuporte
     * @throws ApiError
     */
    public static parceriaTicketsRetrieve(data: ParceriaTicketsRetrieveData): CancelablePromise<ParceriaTicketsRetrieveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/parceria/tickets/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * @param data The data for the request.
     * @param data.id A unique integer value identifying this ticket suporte.
     * @param data.requestBody
     * @returns TicketSuporte
     * @throws ApiError
     */
    public static parceriaTicketsResponderCreate(data: ParceriaTicketsResponderCreateData): CancelablePromise<ParceriaTicketsResponderCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/parceria/tickets/{id}/responder/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}